import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { LineChart, weekSeries } from "./StrategyInsightsModal";
import api from "../lib/api";
import { logError } from "../lib/logger";

export const StrategyPnlModal = ({ strategy, onClose }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!strategy || data) return;
    api.get("/public/strategy-pnl").then((r) => setData(r.data)).catch((e) => logError("strategy pnl", e));
  }, [strategy, data]);

  const s = strategy ? data?.series?.[strategy.key] : null;
  const week = s ? weekSeries(s.points, "pnl", data.week_start, true) : [];
  return (
    <Dialog open={!!strategy} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[#141414] border-white/10 text-white sm:max-w-2xl" data-testid="strategy-pnl-modal">
        <DialogHeader>
          <DialogTitle style={{ color: strategy?.color }} data-testid="strategy-pnl-title">
            Trend PnL · {strategy?.label}
          </DialogTitle>
        </DialogHeader>
        {!data ? (
          <div className="text-sm text-zinc-500 py-10 text-center">Caricamento…</div>
        ) : !s || s.trades === 0 ? (
          <div className="text-sm text-zinc-500 py-10 text-center" data-testid="strategy-pnl-empty">
            Nessun trade chiuso su MT5 per questa strategia.
          </div>
        ) : (
          <div className="bg-black/30 border border-white/10 rounded-md p-3 mt-2" data-testid="strategy-pnl-chart">
            <div className="text-xs text-zinc-400 mb-2">Trend della settimana corrente · conto reale MT5</div>
            <LineChart series={week} valueKey="pnl" color={strategy.color} cur="€" />
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
